export interface ILink {
  [key: string]: string
}
export function videoLinkParser(link: string): ILink {
  const dropboxRegex = /(http|https)?:\/\/(www\.)?dropbox.com\/(.*\?(dl=0))/i;
  const dropboxLink = dropboxRegex.exec(link);
  if (dropboxLink) {
    return { dropboxLink: dropboxLink[0].replace('dl=0', 'raw=1') };
  }
  // eslint-disable-next-line
  const youtubeRegex = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  if (link.match(youtubeRegex)) {
    const match = link.match(youtubeRegex);
    return { youtubeLink: (match && match[2].length === 11) ? match[2] : '' };
  } if (link.includes('https://vimeo.com')) {
    let vimeoLink = link.replace('https://vimeo.com/', '').split('?')[0];
    if (vimeoLink.length === 9) {
      return { vimeoLink };
    }
    const split = link.split('/');
    if (split[3].length <= 9 && parseInt(split[3], 10) > 0) {
      // TODO: to fix
      // eslint-disable-next-line prefer-destructuring
      vimeoLink = split[3];
    } else if (split[4] && split[4].length <= 9 && parseInt(split[4], 10) > 0) {
      // TODO: to fix
      // eslint-disable-next-line prefer-destructuring
      vimeoLink = split[4];
    }
    return { vimeoLink };
  } if (link.includes('watch.videodelivery.net')) {
    return { cloudFlareLink: link.split('net')[1] };
  } if (link.includes('cloudflarestream.com')) {
    return { cloudFlareLink: (link.split('com/')[1] || '').split('/')[0] };
  }
  return { videoLink: link };
}

export function getFileNameFromS3Url(url: string) {
  const SPECIAL_SYMBOL = '--';
  const lastSpecialSymbol = url.lastIndexOf(SPECIAL_SYMBOL);
  return url.substring(lastSpecialSymbol + SPECIAL_SYMBOL.length);
}

export function hideIntercom(company_id: string) {
  return [
    'ffbff742-ff50-48d0-955a-d42309f80d65', /* Disable Intercom for Manara */
    'c70a157e-ad31-40b1-a8e8-4c12085cee84', /* Disable Intercom for Omer test company */
  ].includes(company_id);
}

export const getCookie = (cookieName: string) => (document.cookie.split('; ').find((row) => row.startsWith(`${cookieName}=`)) || '').replace(`${cookieName}=`, '');
